import { uniq } from 'ramda';
import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';

import * as types from './actionTypes';

const setNominationPaths = createAction(types.SET_NOMINATION_PATHS, (path) => ({ path }));
export const reset = createAction(types.RESET);

export const fetchNominatedSellers = (campaignId) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.campaignNominations, {
			replaceParams: {
				id: campaignId,
			},
			onSuccess: [
				(response) => () => {
					const data = response.body;
					if (!data || !Array.isArray(data)) return;

					const allowedPath = {
						regions: [],
						agencies: [],
						managers: [],
						sellers: [],
						ppz: [],
					};

					data.forEach((item) => {
						if (item.regionId && item.agencyId && item.manager && item.seller) {
							if (item.seller) {
								allowedPath.regions.push(item.regionId);
								allowedPath.agencies.push(item.agencyId);
								allowedPath.managers.push(item.manager.login);
								allowedPath.sellers.push(item.seller.login);
							}
							if (item.ppz) {
								allowedPath.ppz.push(item.ppz.login);
							}
						}
					});

					const uniqueAllowedPath = {
						regions: uniq(allowedPath.regions),
						agencies: uniq(allowedPath.agencies),
						managers: uniq(allowedPath.managers),
						sellers: uniq(allowedPath.sellers),
						ppz: uniq(allowedPath.ppz),
					};

					dispatch(setNominationPaths(uniqueAllowedPath));
				},
			],
		}),
	);
};
